import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { CardsSection } from 'components/no-auth/common/sections/CardsSection';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { HeroSection } from '../../components/no-auth/common/sections/HeroSection';
import { HighlightedTilesSection } from '../../components/no-auth/common/sections/HighlightedTilesSection';
import LoneButtonSection from '../../components/no-auth/common/sections/LoneButtonSection';
import { PartnersLogosSection } from '../../components/no-auth/common/sections/PartnersLogosSection/PartnersLogosSection';
import { TileSmallWithImgSection } from '../../components/no-auth/common/sections/TileSmallWithImgSection/TileSmallWithImgSection';
import { TilesSection } from '../../components/no-auth/common/sections/TilesSection';

const BusinessEnterpriseOverviewPage = (props) => {
    return (
        <PromoPageContainer bgColor="baseColor" noIndent>
            {props.heroTitle && (
                <HeroSection title={props.heroTitle} text={props.heroText} data={props.heroData} btnVariant="primary" isInvertedBtn noIconBtn promoDarkPage />
            )}
            <ColoredSectionContainer>
                {props.headline1Title && <HeadingSection whiteTitle title={props.headline1Title} text={props.headline1Text} />}
                {props.partnersLogos && <PartnersLogosSection logos={props.partnersLogos} />}
                {props.headline2Title && <HeadingSection whiteTitle title={props.headline2Title} text={props.headline2Text} />}
                {props.highLightedTiles && <HighlightedTilesSection titleH2 promoDarkPage data={props.highLightedTiles} />}
                {props.headline2Btn && <LoneButtonSection btn={props.headline2Btn} variant={'secondary'} isInverted />}
                {props.headline3Title && <HeadingSection whiteTitle title={props.headline3Title} text={props.headline3Text} />}
                {props.tiles1 && <TilesSection data={props.tiles1} lang={props.lang} country={props.country} isInvertedBtn grayText />}
                {props.headline4Title && <HeadingSection whiteTitle title={props.headline4Title} text={props.headline4Text} />}
                {props.tiles2 && <TilesSection data={props.tiles2} lang={props.lang} country={props.country} isInvertedBtn grayText />}
                {props.headline5Title && <HeadingSection whiteTitle title={props.headline5Title} text={props.headline5Text} />}
                {props.pluginCards && <CardsSection data={props.pluginCards} titleGradient="aubergine04" variant="contentRow" promoDarkPage />}
                {props.headline6Title && <HeadingSection whiteTitle title={props.headline6Title} text={props.headline6Text} />}
                {props.tiles_highlighted_small && <TileSmallWithImgSection data={props.tiles_highlighted_small} />}
            </ColoredSectionContainer>
            <ColoredSectionContainer bottomPadding>
                {props.tiles3 && <TilesSection data={props.tiles3} lang={props.lang} country={props.country} />}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroData: state.extra?.strapiApi?.hero_block,

        headline1Title: state.extra?.strapiApi?.headline_1?.title,
        headline1Text: state.extra?.strapiApi?.headline_1?.text,

        partnersLogos: state.extra?.strapiApi?.partners_logos,

        headline2Title: state.extra?.strapiApi?.headline_2?.title,
        headline2Text: state.extra?.strapiApi?.headline_2?.text,
        headline2Btn: state.extra?.strapiApi?.headline_2?.btn,

        highLightedTiles: state.extra?.strapiApi?.tiles_highlighted,

        headline3Title: state.extra?.strapiApi?.headline_3?.title,
        headline3Text: state.extra?.strapiApi?.headline_3?.text,

        tiles1: state.extra?.strapiApi?.tiles_section_1,

        headline4Title: state.extra?.strapiApi?.headline_4?.title,
        headline4Text: state.extra?.strapiApi?.headline_4?.text,

        tiles2: state.extra?.strapiApi?.tiles_section_2,

        headline5Title: state.extra?.strapiApi?.headline_5?.title,
        headline5Text: state.extra?.strapiApi?.headline_5?.text,

        pluginCards: state.extra?.strapiApi?.plugin_cards,

        headline6Title: state.extra?.strapiApi?.headline_6?.title,
        headline6Text: state.extra?.strapiApi?.headline_6?.text,

        tiles_highlighted_small: state.extra?.strapiApi?.tiles_highlighted_small,

        tiles3: state.extra?.strapiApi?.tiles_section_3,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(BusinessEnterpriseOverviewPage));
